import React from 'react';
import {Helmet} from "react-helmet";
import Header from "../../components/Header";
import IndividualSignUps from "../../components/IndividualSignUp";
import Footer from "../../components/Footer";

import './IndividualSignUp.styles.css'; 

const IndividualSignUp = () => {
	
	return (
		<div>
			<Helmet>
				<title>Individual Sign Up</title>
			</Helmet>
			<Header/>
			<IndividualSignUps/>
			<Footer/>
		</div>
	); 
}; 

export default IndividualSignUp;